import PropTypes from 'prop-types';
import React from 'react';
import { ListColumns, Section } from 'reaxl';
import EmailStaticContent from '../EmailStaticContent';

/**
 *  VehicleOptions component has list of vehicle details and options
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
function VehicleOptions(_ref) {
  let {
    filterValues
  } = _ref;
  return /*#__PURE__*/_jsx(Section, {
    "data-cmp": "vehicle-options",
    alignment: "left",
    className: "margin-bottom-5",
    heading: EmailStaticContent.sectionHeading.quote,
    headingClassName: "margin-top-3 margin-bottom-2",
    uiContext: "section-5",
    children: /*#__PURE__*/_jsx(ListColumns, {
      xs: 2,
      className: "padding-left-0 list-bulleted",
      items: filterValues
    })
  });
}
export default VehicleOptions;